<template>
  <div class="wrapper">
    <b-form class="col-md-12">
      <b-row>
        <b-col sm="12">
          <b-alert v-if="FormCompleted" show variant="primary"
            >Bahagian ini telah lengkap. ✔</b-alert
          >
          <b-alert v-else show variant="warning"
            >Bahagian ini tidak lengkap.</b-alert
          >
          <hr />
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <b-form-group label-for="EmploymentSector">
            <template v-slot:label>
              Sektor Pekerjaan
              <span v-if="EmploymentSectorId == 0" class="text-danger">*</span>
              <span v-else>✔</span>
            </template>
            <b-form-select
              :disabled="Busy === true || Submitted === true"
              v-model="EmploymentSectorId"
            >
              <DefaultOption />
              <option
                v-for="item in EmploymentSector"
                v-bind:value="item.Id"
                :key="item.Id"
              >
                {{ item.Sector | titleCase }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <template
        v-if="
          EmploymentSectorId == 1 ||
          EmploymentSectorId == 2 ||
          EmploymentSectorId == 3 ||
          EmploymentSectorId == 5 ||
          EmploymentSectorId == 6
        "
      >
        <b-row>
          <b-col
            sm="6"
            v-if="EmploymentSectorId == 1 || EmploymentSectorId == 2 || EmploymentSectorId == 3 || EmploymentSectorId == 5"
          >
            <b-form-group label-for="EmployerName">
              <template v-slot:label>
                Nama Majikan
                <span v-if="!EmployerName" class="text-danger">*</span>
                <span v-else>✔</span>
              </template>
              <b-form-input
                type="text"
                :disabled="Busy === true || Submitted === true"
                v-model.trim="EmployerName"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label-for="TypeOfWork">
              <template v-slot:label>
                Jawatan / Pekerjaan
                <span v-if="!TypeOfWork" class="text-danger">*</span>
                <span v-else>✔</span>
              </template>
              <b-form-input
                type="text"
                :disabled="Busy === true || Submitted === true"
                v-model.trim="TypeOfWork"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group label-for="IncomeTaxNo">
              <template v-slot:label>No. Cukai Pendapatan</template>
              <b-form-input
                type="text"
                :disabled="Busy === true || Submitted === true"
                v-model="IncomeTaxNo"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label-for="MonthlyIncome">
              <template v-slot:label>
                Pendapatan Sebulan (RM)
                <span v-if="MonthlyIncome == 0" class="text-danger">*</span>
                <span v-else>✔</span>
              </template>
              <b-form-input
                placeholder="0.00"
                type="number"
                min="1"
                :disabled="Busy === true || Submitted === true"
                v-model="MonthlyIncome"
                @keydown ="calculated = 1;"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group label-for="YearlyIncome">
              <template v-slot:label>
                Pendapatan Bercukai Tahunan/Pendapatan Setahun (RM)
                <span v-if="YearlyIncome == 0" class="text-danger">*</span>
                <span v-else>✔</span>
              </template>
              <b-form-input
                placeholder="0.00"
                type="number"
                min="0.00"
                :disabled="Busy === true || Submitted === true"
                v-model="YearlyIncome"
              ></b-form-input>
              <Button icon="pi pi-question-circle" class="p-button-rounded p-button-text p-button-help mt-1" @click="viewSampleBE()" v-tooltip.top="'LIHAT CONTOH'" />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label-for="OtherIncome">
              <template v-slot:label>
                Sumber Pendapatan Lain (RM)
                <!-- <span v-if="OtherIncome == 0" class="text-danger">*</span>
                <span v-else>✔</span> -->
              </template>
              <b-form-input
                placeholder="0.00"
                type="number"
                min="0.00"
                step="10.00"
                :disabled="Busy === true || Submitted === true"
                v-model="OtherIncome"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Add Label cm#4 -->
        <b-row>
          <b-col sm="6">
            <b-alert show variant="secondary">Pendapatan Bercukai Tahunan/Pendapatan Setahun (RM) boleh dikemaskini jika tidak tepat</b-alert>
          </b-col>
          <b-col sm="6">
          </b-col>
        </b-row>
        <!-- Add Label cm#4 -->
      </template>
    </b-form>
    <template v-if="EmploymentSectorId == 1 || EmploymentSectorId == 2 || EmploymentSectorId == 3 || EmploymentSectorId == 5">
      <hr />
      <b-col sm="6">
        <p class="lead">Majikan - Maklumat Untuk Dihubungi</p>
      </b-col>
      <b-form class="col-md-12">
        <b-row>
          <b-col sm="6">
            <b-form-group label="Emel" v-bind:label-for="others + 'Email'">
              <b-form-input
                v-bind:id="others + 'Email'"
                type="email"
                placeholder="Cth: pelajar@google.com"
                autocomplete="email"
                :disabled="Busy === true || Submitted === true"
                v-model="Email"
              ></b-form-input>
              <span class="error" v-show="Email &amp;&amp; !isEmailValid">
                <span style="color: red">Invalid e-mail</span>
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <b-form-group
              label="Telefon (Rumah)"
              v-bind:label-for="others + 'fixPhone'"
            >
              <b-form-input
                v-bind:id="others + 'fixPhone'"
                placeholder="Cth: 0340526617"
                :disabled="Busy === true || Submitted === true"
                v-model="FixPhoneNo"
                maxlength="11"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
              label="Telefon (Bimbit)"
              v-bind:label-for="others + 'mobilePhone'"
            >
              <b-form-input
                v-bind:id="others + 'mobilePhone'"
                placeholder="Cth: 0134052667"
                :disabled="Busy === true || Submitted === true"
                v-model="MobilePhoneNo"
                maxlength="11"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr />

        <b-row>
          <b-col sm="6">
            <p class="lead">Alamat Majikan</p>
            <b-alert v-if="AddressId == 0" show variant="warning"
              >Sila klik butang kemaskini untuk tambahan atau pertukaran
              alamat.</b-alert
            >
          </b-col>

          <b-col sm="6">
            <div class="float-right">
              <b-dropdown
                :disabled="Busy == true || Submitted === true"
                v-bind:id="others + 'ddownEmployer'"
                text="Tindakan"
                class="m-2"
                variant="primary"
              >
                <b-dropdown-item @click="addAddressModal = true"
                  >Tambah</b-dropdown-item
                >
                <template v-if="AddressId !== 0">
                  <b-dropdown-item
                    @click="(editAddressModal = true), (type = 'employment')"
                    >Edit</b-dropdown-item
                  >
                </template>
                <b-dropdown-item
                  @click="(chooseAddressModal = true), (type = 'employment')"
                  >Pilih</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6">
            <span>
              <div>
                <template v-if="Address1 !== ''">{{ Address1 }},</template>
                <template v-if="Address2 !== ''">{{ Address2 }},</template>
                <template v-if="Address3 !== ''">{{ Address3 }},</template>
              </div>

              <div>
                <template v-if="Postcode !== ''">{{ Postcode }},</template>
                <template v-if="CountryId === 130"><template v-if="CityId > 0">{{ CityName }},
                    <br />
                  </template>
                  <template v-if="StateId > 0">{{ StateName }},</template>
                </template>
                <template v-else>
                  <template v-if="OtherStateName !== ''">{{ OtherStateName }},</template>
                </template>
                <template v-if="CountryId > 0">{{CountryName }}</template>
              </div>
            </span>
          </b-col>
        </b-row>
      </b-form>
    </template>

    <!-- Modal Component -->
    <b-modal
      title="Tambah Alamat Baru"
      variant="primary"
      header-bg-variant="primary"
      :disabled="Busy === true || Submitted === true"
      v-model="addAddressModal"
      @ok="InsertAddress"
    >
      <AddressBook type="insert" />
    </b-modal>
    <b-modal
      title="Edit Alamat"
      variant="primary"
      header-bg-variant="primary"
      :disabled="Busy === true || Submitted === true"
      v-model="editAddressModal"
      @ok="UpdateAddress"
    >
      <template v-if="others == 'spouse'">
        <AddressBook type="employment" others="spouse" />
      </template>
      <template v-else-if="others == 'father'">
        <AddressBook type="employment" others="father" />
      </template>
      <template v-else-if="others == 'mother'">
        <AddressBook type="employment" others="mother" />
      </template>
      <template v-else-if="others == 'guardian'">
        <AddressBook type="employment" others="guardian" />
      </template>
      <template v-else-if="others == 'family'">
        <AddressBook type="employment" others="family" />
      </template>
      <template v-else-if="others == 'guarantor'">
        <AddressBook type="employment" others="guarantor" />
      </template>
    </b-modal>
    <b-modal
      title="Pilih Alamat"
      variant="primary"
      header-bg-variant="primary"
      :disabled="Busy === true || Submitted === true"
      v-model="chooseAddressModal"
      @ok="ChangeAddress"
    >
      <AddressList />
    </b-modal>
    <Dialog header="Contoh Penyata BE" :visible.sync="displaySampleBE" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :containerStyle="{width: '75vw'}"
      :modal="true"
      :maximizable="true">
      <div style="text-align:center">
        <div style="text-align: center">
          <img
            src="../assets/media/BESample1.jpg"
            border="0"
            width="75%"
            height="75%"
          />
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import DefaultOption from "./DefaultOption";
import AddressBook from "./AddressBook";
import AddressList from "./AddressList";
import Vue from "vue";
import PrimeVue from 'primevue/config';
Vue.use(PrimeVue);
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Tooltip from 'primevue/tooltip';

export default {
  name: "EmploymentDetails",
  props: ["others"],
  components: {
    DefaultOption,
    AddressBook,
    AddressList,
    Button,
    Dialog,
    Tooltip,
  },
  data: function () {
    return {
      AddressBooks: {},
      EmploymentSector: {},

      addAddressModal: false,
      editAddressModal: false,
      chooseAddressModal: false,

      type: "employer",

      Address1: "",
      Address2: "",
      Address3: "",
      Postcode: "",
      CityId: 0,
      StateId: 0,
      CountryId: 0,
      CityName: "",
      StateName: "",
      OtherStateName: "",
      CountryName: "",

      calculated: 0,
      displaySampleBE: false,
      sCFN: 'OthersEmploymentDetails: ',
      YearlyIncomeFromDB: 0,
    };
  },
  created() {
    Vue.directive('tooltip', Tooltip);
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.GetEmploymentType();
      this.GetEmploymentDetails();
      this.GetEmploymentHistory();
      this.GetEmployerAddress();
      this.GetEmploymentContactDetails();
    }
  },
  computed: {
    FormCompleted: {
      get: function () {
        let complete = true;

        if (
          // this.EmploymentSectorId == 3 ||
          // this.EmploymentSectorId == 5 ||
          this.EmploymentSectorId == 8 ||
          this.EmploymentSectorId == 10
        ) {
          this.$store.dispatch(
            this.others + "EmploymentDetails/updateFormCompleted",
            complete
          );
          return complete;
        } else {
          {
            if (this.EmploymentSectorId == 1 || this.EmploymentSectorId == 2) {
              if (!this.EmployerName) complete = false;
            }

            if (this.EmploymentSectorId != 6) {
              if (!this.EmployerName) complete = false;
            }

            if (!this.TypeOfWork) complete = false;

            if (this.MonthlyIncome == 0) complete = false;
          }
          this.$store.dispatch(
            this.others + "EmploymentDetails/updateFormCompleted",
            complete
          );
          return complete;
        }
      },
    },
    Busy: {
      get: function () {
        return this.$store.getters["common/Busy"];
      },
      set: function (value) {
        this.$store.dispatch("common/updateBusy", value);
      },
    },
    Submitted: {
      get: function () {
        return this.$store.getters["common/Submitted"];
      },
    },
    ContactModule: {
      get: function () {
        return this.others + "EmploymentContactDetails";
      },
    },
    // Address
    SelectedId: {
      get: function () {
        return this.$store.getters["addressBook/SelectedId"];
      },
      set: function (value) {
        this.$store.dispatch("addressBook/updateSelectedId", value);
      },
    },
    AddressId: {
      get: function () {
        return this.$store.getters[this.others + "EmploymentHistory/EmployerAddress"];
      },
      set: function (value) {
        this.$store.dispatch(this.others + "EmploymentHistory/updateEmployerAddress", value);
      },
    },
    // Employment History
    MonthlyIncome: {
      get: function () {
        if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
          return this.MotherMonthlyIncome;
        }
        if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
          return this.FatherMonthlyIncome;
        }
        return this.$store.getters[this.others + "EmploymentHistory/MonthlyIncome"];
      },
      set: function (value) {
        //this.HTECHLogger('set MonthlyIncome: ' + value + ' | calculated = ' + this.calculated)
        if (1 == this.calculated) {
          this.YearlyIncomeFromDB = value * 12;
          //this.HTECHLogger('yearlyincome: ' + this.YearlyIncomeFromDB + ' this.others = ' + this.others + ' | RIDV4 = ' + this.RelationshipIdV4)
        }
        if (16 == this.RelationshipIdV4) {
          if ('father' == this.others) {
            this.$store.dispatch("fatherEmploymentHistory/updateMonthlyIncome", value);
          } else {
            this.$store.dispatch("motherEmploymentHistory/updateMonthlyIncome", value);
          }
        } else if (17 == this.RelationshipIdV4) {
          if ('mother' == this.others) {
            this.$store.dispatch("motherEmploymentHistory/updateMonthlyIncome", value);
          } else {
            this.$store.dispatch("fatherEmploymentHistory/updateMonthlyIncome", value);
          }
        } else {
          this.$store.dispatch(this.others + "EmploymentHistory/updateMonthlyIncome", value);
        }
      },
    },
    Position: {
      get: function () {
        return this.$store.getters[this.others + "EmploymentHistory/Position"];
      },
      set: function (value) {
        this.$store.dispatch(this.others + "EmploymentHistory/updatePosition", value);
      },
    },
    TypeOfWork: {
      get: function () {
        if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
          return this.MotherTypeOfWork;
        }
        if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
          return this.FatherTypeOfWork;
        }
        return this.$store.getters[this.others + "EmploymentHistory/TypeOfWork"];
      },
      set: function (value) {
        if (16 == this.RelationshipIdV4) {
          this.$store.dispatch("motherEmploymentHistory/updateTypeOfWork", value);
        } else if (17 == this.RelationshipIdV4) {
          this.$store.dispatch("fatherEmploymentHistory/updateTypeOfWork", value);
        } else {
          this.$store.dispatch(this.others + "EmploymentHistory/updateTypeOfWork", value);
        }
      },
    },
    EmployerName: {
      get: function () {
        if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
          return this.MotherEmployerName;
        }
        if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
          return this.FatherEmployerName;
        }
        return this.$store.getters[this.others + "EmploymentHistory/EmployerName"];
      },
      set: function (value) {
        if (16 == this.RelationshipIdV4) {
          this.$store.dispatch("motherEmploymentHistory/updateEmployerName", value);
        } else if (17 == this.RelationshipIdV4) {
          this.$store.dispatch("fatherEmploymentHistory/updateEmployerName", value);
        } else {
          this.$store.dispatch(this.others + "EmploymentHistory/updateEmployerName", value);
        }
      },
    },
    EmployerAddressId: {
      get: function () {
        return this.$store.getters[this.others + "EmploymentHistory/EmployerAddress"]; 
      },
      set: function (value) {
        this.$store.dispatch(this.others + "EmploymentHistory/updateEmployerAddress", value);
      },
    },
    EmploymentSectorId: {
      get: function () {
        if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
          return this.MotherEmploymentSectorId;
        }
        if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
          return this.FatherEmploymentSectorId;
        }
        return this.$store.getters[this.others + "EmploymentHistory/EmploymentSector"];
      },
      set: function (value) {
        if (16 == this.RelationshipIdV4) {
          this.$store.dispatch("motherEmploymentHistory/updateEmploymentSector", value);
        } else if (17 == this.RelationshipIdV4) {
          this.$store.dispatch("fatherEmploymentHistory/updateEmploymentSector", value);
        } else {
          this.$store.dispatch(this.others + "EmploymentHistory/updateEmploymentSector", value);
        }
      },
    },
    YearlyIncome: {
      get: function () {
        if (0 == this.YearlyIncomeFromDB) {
          var t = this.MonthlyIncome * 12;
          this.$store.dispatch(this.others + "EmploymentDetails/updateYearlyIncome", t);
          return t.toFixed(2);
        }
        var t = this.YearlyIncomeFromDB;
        return t.toFixed(2);
      },
      set: function (value) {
        this.$store.dispatch(this.others + "EmploymentDetails/updateYearlyIncome", value);
      },
    },
    OtherIncome: {
      get: function () {
        if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
          return this.MotherOtherIncome;
        }
        if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
          return this.FatherOtherIncome;
        }
        return this.$store.getters[this.others + "EmploymentDetails/OtherIncome"];
      },
      set: function (value) {
        if (16 == this.RelationshipIdV4) {
          this.$store.dispatch("motherEmploymentDetails/updateOtherIncome", value);
        } else if (17 == this.RelationshipIdV4) {
          this.$store.dispatch("fatherEmploymentDetails/updateOtherIncome", value);
        } else {
          this.$store.dispatch(this.others + "EmploymentDetails/updateOtherIncome", value);
        }
      },
    },
    IncomeTaxNo: {
      get: function () {
        if ((16 == this.RelationshipIdV4) && ('mother' == this.others || 'guardian' == this.others)) {
          return this.MotherIncomeTaxNo;
        }
        if ((17 == this.RelationshipIdV4) && ('father' == this.others || 'guardian' == this.others)) {
          return this.FatherIncomeTaxNo;
        }
        return this.$store.getters[this.others + "EmploymentDetails/IncomeTaxNo"];
      },
      set: function (value) {
        if (16 == this.RelationshipIdV4) {
          this.$store.dispatch("motherEmploymentDetails/updateIncomeTaxNo", value);
        } else if (17 == this.RelationshipIdV4) {
          this.$store.dispatch("fatherEmploymentDetails/updateIncomeTaxNo", value);
        } else {
          this.$store.dispatch(this.others + "EmploymentDetails/updateIncomeTaxNo", value);
        }
      },
    },
    EmploymentStatus: {
      get: function () {
        return this.$store.getters[this.others + "EmploymentDetails/EmploymentStatus"];
      },
      set: function (value) {
        this.$store.dispatch(this.others + "EmploymentDetails/updateEmploymentStatus", value);
      },
    },
    RetirementStatus: {
      get: function () {
        return this.$store.getters[this.others + "EmploymentDetails/RetirementStatus"];
      },
      set: function (value) {
        this.$store.dispatch(this.others + "EmploymentDetails/updateRetirementStatus", value);
      },
    },

    // Contact Details
    Email: {
      get: function () {
        return this.$store.getters[this.ContactModule + "/Email"];
      },
      set: function (value) {
        this.$store.dispatch(this.ContactModule + "/updateEmail", value);
      },
    },
    FixPhoneNo: {
      get: function () {
        return this.$store.getters[this.ContactModule + "/FixPhoneNo"];
      },
      set: function (value) {
        this.$store.dispatch(this.ContactModule + "/updateFixPhoneNo", value);
      },
    },
    MobilePhoneNo: {
      get: function () {
        return this.$store.getters[this.ContactModule + "/MobilePhoneNo"];
      },
      set: function (value) {
        this.$store.dispatch(this.ContactModule + "/updateMobilePhoneNo", value);
      },
    },
    FaxNo: {
      get: function () {
        return this.$store.getters[this.ContactModule + "/FaxNo"];
      },
      set: function (value) {
        this.$store.dispatch(this.ContactModule + "/updateFaxNo", value);
      },
    },
    // To populate information of father or mother 
    RelationshipIdV4: {
      get: function() {
        return this.$store.getters["appPersonalDetails/RelationshipV4"];
      },
      set: function(value) {
        this.$store.dispatch("appPersonalDetails/updateRelationshipV4", value);
      }
    },
    // Father Employment
    FatherYearlyIncome: {
      get: function () {
        return this.$store.getters["fatherEmploymentDetails/YearlyIncome"];
      },
      set: function (value) {
        this.$store.dispatch("fatherEmploymentDetails/updateYearlyIncome", value);
      },
    },
    FatherOtherIncome: {
      get: function () {
        return this.$store.getters["fatherEmploymentDetails/OtherIncome"];
      },
      set: function (value) {
        this.$store.dispatch("fatherEmploymentDetails/updateOtherIncome", value);
      },
    },
    FatherIncomeTaxNo: {
      get: function () {
        return this.$store.getters["fatherEmploymentDetails/IncomeTaxNo"];
      },
      set: function (value) {
        this.$store.dispatch("fatherEmploymentDetails/updateIncomeTaxNo", value);
      },
    },
    FatherEmploymentStatus: {
      get: function () {
        return this.$store.getters["fatherEmploymentDetails/EmploymentStatus"];
      },
      set: function (value) {
        this.$store.dispatch("fatherEmploymentDetails/updateEmploymentStatus", value);
      },
    },
    FatherPosition: {
      get: function () {
        return this.$store.getters["fatherEmploymentHistory/Position"];
      },
      set: function (value) {
        this.$store.dispatch("fatherEmploymentHistory/updatePosition", value);
      },
    },
    FatherTypeOfWork: {
      get: function () {
        return this.$store.getters["fatherEmploymentHistory/TypeOfWork"];
      },
      set: function (value) {
        this.$store.dispatch("fatherEmploymentHistory/updateTypeOfWork", value);
      },
    },
    FatherMonthlyIncome: {
      get: function () {
        return this.$store.getters["fatherEmploymentHistory/MonthlyIncome"];
      },
      set: function (value) {
        this.$store.dispatch("fatherEmploymentHistory/updateMonthlyIncome", value);
      },
    },
    FatherEmployerName: {
      get: function () {
        return this.$store.getters["fatherEmploymentHistory/EmployerName"];
      },
      set: function (value) {
        this.$store.dispatch("fatherEmploymentHistory/updateEmployerName", value);
      },
    },
    FatherEmployerAddressId: {
      get: function () {
        return this.$store.getters["fatherEmploymentHistory/EmployerAddress"]; 
      },
      set: function (value) {
        this.$store.dispatch("fatherEmploymentHistory/updateEmployerAddress", value);
      },
    },
    FatherEmploymentSectorId: {
      get: function () {
        return this.$store.getters["fatherEmploymentHistory/EmploymentSector"];
      },
      set: function (value) {
        this.$store.dispatch("fatherEmploymentHistory/updateEmploymentSector", value);
      },
    },
    // Mother Employment
    MotherYearlyIncome: {
      get: function () {
        return this.$store.getters["motherEmploymentDetails/YearlyIncome"];
      },
      set: function (value) {
        this.$store.dispatch("motherEmploymentDetails/updateYearlyIncome", value);
      },
    },
    MotherOtherIncome: {
      get: function () {
        return this.$store.getters["motherEmploymentDetails/OtherIncome"];
      },
      set: function (value) {
        this.$store.dispatch("motherEmploymentDetails/updateOtherIncome", value);
      },
    },
    MotherIncomeTaxNo: {
      get: function () {
        return this.$store.getters["motherEmploymentDetails/IncomeTaxNo"];
      },
      set: function (value) {
        this.$store.dispatch("motherEmploymentDetails/updateIncomeTaxNo", value);
      },
    },
    MotherEmploymentStatus: {
      get: function () {
        return this.$store.getters["motherEmploymentDetails/EmploymentStatus"];
      },
      set: function (value) {
        this.$store.dispatch("motherEmploymentDetails/updateEmploymentStatus", value);
      },
    },
    MotherPosition: {
      get: function () {
        return this.$store.getters["motherEmploymentHistory/Position"];
      },
      set: function (value) {
        this.$store.dispatch("motherEmploymentHistory/updatePosition", value);
      },
    },
    MotherTypeOfWork: {
      get: function () {
        return this.$store.getters["motherEmploymentHistory/TypeOfWork"];
      },
      set: function (value) {
        this.$store.dispatch("motherEmploymentHistory/updateTypeOfWork", value);
      },
    },
    MotherMonthlyIncome: {
      get: function () {
        return this.$store.getters["motherEmploymentHistory/MonthlyIncome"];
      },
      set: function (value) {
        this.$store.dispatch("motherEmploymentHistory/updateMonthlyIncome", value);
      },
    },
    MotherEmployerName: {
      get: function () {
        return this.$store.getters["motherEmploymentHistory/EmployerName"];
      },
      set: function (value) {
        this.$store.dispatch("motherEmploymentHistory/updateEmployerName", value);
      },
    },
    MotherEmployerAddressId: {
      get: function () {
        return this.$store.getters["motherEmploymentHistory/EmployerAddress"]; 
      },
      set: function (value) {
        this.$store.dispatch("motherEmploymentHistory/updateEmployerAddress", value);
      },
    },
    MotherEmploymentSectorId: {
      get: function () {
        return this.$store.getters["motherEmploymentHistory/EmploymentSector"];
      },
      set: function (value) {
        this.$store.dispatch("motherEmploymentHistory/updateEmploymentSector", value);
      },
    },
  },
  methods: {
    GetEmploymentType() {
      this.$API
        .get(this.$EmploymentType, { withCredentials: true })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.EmploymentSector = response.data;
          }
        });
    },
    GetEmploymentDetails() {
      let fN = 'GetEmploymentDetails: ';
      this.$API
        .get(this.$EmploymentDetails + "/" + this.others, { withCredentials: true, })
        .then((response) => {
          this.info = response.data;
          //this.HTECHLogger(this.sCFN + fN + '| ' + this.others + ' | ' + 'response.data = ' + JSON.stringify(response.data))
          if (response.status == 200 && this.info != null) {
            this.YearlyIncomeFromDB = this.info.YearlyIncome;
            this.YearlyIncome = this.info.YearlyIncome;
            this.OtherIncome = this.info.OtherIncome;
            this.IncomeTaxNo = this.info.IncomeTaxNo;
            this.EmploymentStatus = this.info.EmploymentStatus;
            if ('father' === this.others) {
              this.FatherYearlyIncome = this.info.YearlyIncome;
              this.FatherOtherIncome = this.info.OtherIncome;
              this.FatherIncomeTaxNo = this.info.IncomeTaxNo;
              this.FatherEmploymentStatus = this.info.EmploymentStatus;
            }
            if ('mother' === this.others) {
              this.MotherYearlyIncome = this.info.YearlyIncome;
              this.MotherOtherIncome = this.info.OtherIncome;
              this.MotherIncomeTaxNo = this.info.IncomeTaxNo;
              this.MotherEmploymentStatus = this.info.EmploymentStatus;
            }
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetEmploymentHistory() {
      this.$API
        .get(this.$EmploymentHistory + "/" + this.others, { withCredentials: true, })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.Position = this.info.Position;
            this.TypeOfWork = this.info.TypeOfWork;
            this.MonthlyIncome = this.info.MonthlyIncome;
            this.EmployerName = this.info.EmployerName;
            this.EmployerAddressId = this.info.EmployerAddressId;
            this.EmploymentSectorId = this.info.EmploymentSectorId;
            if ('father' === this.others) {
              this.FatherPosition = this.info.Position;
              this.FatherTypeOfWork = this.info.TypeOfWork;
              this.FatherMonthlyIncome = this.info.MonthlyIncome;
              this.FatherEmployerName = this.info.EmployerName;
              this.FatherEmployerAddressId = this.info.EmployerAddressId;
              this.FatherEmploymentSectorId = this.info.EmploymentSectorId;
            }
            if ('mother' === this.others) {
              this.MotherPosition = this.info.Position;
              this.MotherTypeOfWork = this.info.TypeOfWork;
              this.MotherMonthlyIncome = this.info.MonthlyIncome;
              this.MotherEmployerName = this.info.EmployerName;
              this.MotherEmployerAddressId = this.info.EmployerAddressId;
              this.MotherEmploymentSectorId = this.info.EmploymentSectorId;
            }
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetEmploymentContactDetails() {
      this.$API
        .get(this.$EmploymentContactDetails + "/" + this.others, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.Email = this.info.Email;
            this.FixPhoneNo = this.info.FixPhoneNo;
            this.MobilePhoneNo = this.info.MobilePhoneNo;
            this.FaxNo = this.info.FaxNo;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetEmployerAddress() {
      this.$API
        .get(this.$EmploymentAddress + "/" + this.others, {
          withCredentials: true,
        })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.SelectedId = this.info.Id;
            this.EmployerAddressId = this.info.Id;

            this.AddressId = this.info.Id;
            this.Address1 = null != this.info.Address1 ? this.info.Address1.toUpperCase() : this.info.Address1;
            this.Address2 = null != this.info.Address2 ? this.info.Address2.toUpperCase() : this.info.Address2;
            this.Address3 = null != this.info.Address3 ? this.info.Address3.toUpperCase() : this.info.Address3;
            this.Postcode = null != this.info.Postcode ? this.info.Postcode.toUpperCase() : this.info.Postcode;
            this.CityId = this.info.CityId;
            this.CityName = null != this.info.CityName ? this.info.CityName.toUpperCase() : this.info.CityName;
            this.StateId = this.info.StateId;
            this.StateName = null != this.info.StateName ? this.info.StateName.toUpperCase() : this.info.StateName;
            this.OtherStateName = null != this.info.OtherStateName ? this.info.OtherStateName.toUpperCase() : this.info.OtherStateName;
            this.CountryId = this.info.CountryId;
            this.CountryName = this.info.CountryName.toUpperCase();
            this.CountryName = null != this.info.CountryName ? this.info.CountryName.toUpperCase() : this.info.CountryName;

            if (this.AddressId === null) this.AddressId = 0;
            if (this.Address1 === null) this.Address1 = "";
            if (this.Address2 === null) this.Address2 = "";
            if (this.Address3 === null) this.Address3 = "";
            if (this.Postcode === null) this.Postcode = "";
            if (this.CityName === null) this.CityName = "";
            if (this.StateName === null) this.StateName = "";
            if (this.OtherStateName === null) this.OtherStateName = "";
            if (this.CountryName === null) this.CountryName = "";
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    InsertAddress() {
      const formData = new FormData();

      formData.append("Address1", this.$store.getters["addressBook/Address1"]);
      formData.append("Address2", this.$store.getters["addressBook/Address2"]);
      formData.append("Address3", this.$store.getters["addressBook/Address3"]);
      formData.append("Postcode", this.$store.getters["addressBook/Postcode"]);
      formData.append("CityId", this.$store.getters["addressBook/CityId"]);
      formData.append("StateId", this.$store.getters["addressBook/StateId"]);
      formData.append(
        "CountryId",
        this.$store.getters["addressBook/CountryId"]
      );
      formData.append(
        "OtherStateName",
        this.$store.getters["addressBook/OtherStateName"]
      );

      this.$API
        .post(this.$InsertAddress, formData, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          var newId = this.info;
          if (response.status == 200) {
            this.$API
              .get(
                this.$UpdateAddress + "/" + this.others + "/employer/" + newId,
                { withCredentials: true }
              )
              .then((response) => {
                if (response.status == 200) {
                  // Reload addresses displayed
                  this.GetEmployerAddress();

                  this.addAddressModal = false;
                  console.log("Address Added");
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else console.log("Error Adding.");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    UpdateAddress() {
      const formData = new FormData();

      formData.append("Id", this.$store.getters["addressBook/Id"]);
      formData.append("Address1", this.$store.getters["addressBook/Address1"]);
      formData.append("Address2", this.$store.getters["addressBook/Address2"]);
      formData.append("Address3", this.$store.getters["addressBook/Address3"]);
      formData.append("Postcode", this.$store.getters["addressBook/Postcode"]);
      formData.append("CityId", this.$store.getters["addressBook/CityId"]);
      formData.append("StateId", this.$store.getters["addressBook/StateId"]);
      formData.append(
        "CountryId",
        this.$store.getters["addressBook/CountryId"]
      );
      formData.append(
        "OtherStateName",
        this.$store.getters["addressBook/OtherStateName"]
      );

      this.$API
        .post(this.$UpdateAddress, formData, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            // Reload addresses displayed
            this.GetEmployerAddress(this.others);

            this.editAddressModal = false;
            console.log("Address Updated");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    ChangeAddress() {
      var url =
        this.$UpdateAddress +
        "/" +
        this.others +
        "/employer/" +
        this.SelectedId;

      this.$API
        .get(url, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200) {
            // Reload addresses displayed
            // TODO
            this.EmployerAddressId = this.SelectedId;
            this.GetEmployerAddress();

            this.chooseAddressModal = false;
            console.log("Address changed");
          } else console.log("Error Saving");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    viewSampleBE() {
      this.displaySampleBE = true;
    },
  },
};
</script>
